//#region src/tax_rate_type.ts
var TaxRateType = /* @__PURE__ */ function(TaxRateType) {
	TaxRateType[TaxRateType["Percent"] = 0] = "Percent";
	TaxRateType[TaxRateType["FixedUnimplemented"] = 1] = "FixedUnimplemented";
	return TaxRateType;
}(TaxRateType || {});
//#endregion
export { TaxRateType };

//# sourceMappingURL=tax_rate_type.js.map